import { render, staticRenderFns } from "./LbaNumber.vue?vue&type=template&id=2ca43242"
import script from "./LbaNumber.vue?vue&type=script&lang=js"
export * from "./LbaNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports